var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "ci-user-profile-interest-tags ci-card ci-section ci-content-padding",
    },
    [
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: "flex-grow-1" }, [
          _c("h3", {
            staticClass: "h5 mb-0",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.users.profile.interests.title")
              ),
            },
          }),
        ]),
        _vm.items.length !== 0 && _vm.owner
          ? _c(
              "div",
              { staticClass: "flex-shrink-0" },
              [
                _c("ci-button", {
                  staticClass: "mr-n2 mt-n2",
                  attrs: {
                    icon: "mdi-cog",
                    label: _vm.$t("ui.shared.global.edit"),
                  },
                  on: { click: _vm.handleEditInterestTagsClick },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-wrap justify-content-start align-items-center",
        },
        [
          _vm.items.length === 0 && _vm.owner
            ? [
                _c("div", { staticClass: "flex-column w-100" }, [
                  _c("p", {
                    staticClass: "mr-2",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "ui.components.users.profile.interests.empty_state"
                        )
                      ),
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "row flex-center" },
                    [
                      _c("ci-button", {
                        attrs: {
                          icon: "mdi-plus",
                          label: _vm.$t(
                            "ui.components.users.profile.interests.action"
                          ),
                          variant: "outline-primary",
                        },
                        on: { click: _vm.handleEditInterestTagsClick },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            : [
                _vm.userHasDefaultInterests
                  ? [
                      _c("div", { staticClass: "flex-column w-100 mb-2" }, [
                        _c("span", {
                          staticClass: "text-muted",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "ui.components.users.profile.interests.default"
                              )
                            ),
                          },
                        }),
                      ]),
                    ]
                  : _vm._e(),
                _c("ci-interest-tags", {
                  attrs: {
                    "interest-tags": _vm.items,
                    "tag-tracking-target-name": "TagUserProfile",
                    "tag-tracking-identifier-override": _vm.trackingUserType,
                    context: "articles",
                    variant: "link",
                    clamp: "2",
                    "show-expand-cta": true,
                  },
                }),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }